import { JDSFooterIconLinksProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFooterIconLinksProps>
  ): React.FC<JDSFooterIconLinksProps> =>
  (props: JDSFooterIconLinksProps) => {
    return <Component {...props} />;
  };
